import { CalendarSettingsType } from '../calendar-types';

export function getWholeWidth(settings: Partial<CalendarSettingsType>) {
  const { stepWidth = 100, startingHour = 0, endingHour = 24 } = settings;
  return (endingHour - startingHour) * stepWidth;
}
